import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Text } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";
import { useInfo24H } from "@app/hooks/trade/info24H.tsx";
import { useIndexPrice } from "@app/hooks/trade/indexprice";
import { CurrencySymbol } from '@utils/CurrencySymbol.tsx';
import { getBigNumber } from '@utils/getBigNumber.tsx';
import { useCurrencyConverter } from '@utils/CurrencyConverter.tsx';
import throttle from 'lodash/throttle';
import BigNumber from 'bignumber.js';

const MarketTableListItems = ({
  ep_id,
  type,
  item,
  color,
  fontSize,
  fontWeight,
}: any) => {
  const { textw, raise, fail } = useContext(ThemeContext).theme.COLORS;

  const convertCurrency = useCurrencyConverter();
  const [throttledPrice, setThrottledPrice] = useState(0);

  const throttledUpdate = useMemo(
    () =>
      throttle((price) => {
        setThrottledPrice(price);
      }, 1000),
    [convertCurrency]
  );


  useEffect(() => {
    if (!item) return;

    throttledUpdate(item);

    return () => {
      throttledUpdate.cancel();
    };
  }, [item, throttledUpdate]);



  const checkitem = item;


  return (
    <Text
      size={fontSize ? fontSize : 14}
      style={{
        fontWeight: fontWeight ? fontWeight : "600",
        color:
          type == "price" || type == "rate"
            ? checkitem > 0
              ? raise
              : checkitem < 0
              ? fail
              : undefined
            : color
            ? color
            : undefined,
      }}
    >
      {type == "price" ? CurrencySymbol() + ' ' + BigNumber(throttledPrice) : item} {type == "rate" ? "%" : ""}
    </Text>
  );
};

export default React.memo(MarketTableListItems);
